import { createContext } from 'react';

export const DropdownMenuContext = createContext<{
  /**
   * This value is only to be used internally to trigger a force close of the dropdown menu.
   */
  _forceCloseCounter: number;
  forceClose: () => void;
}>({
  _forceCloseCounter: 0,
  forceClose: () => {},
});
